import React, { type FC } from 'react'
import { SvgIcon, type SvgIconProps } from '@mui/material'

export const CloseIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon data-testid="CloseIcon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="icon/close">
            <path fill="none" d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
        </g>
    </SvgIcon>
)
